"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Theming = exports.defaultTheme = void 0;
const react_1 = require("react");
const react_jss_1 = require("react-jss");
const create_theme_1 = __importDefault(require("./create-theme"));
exports.defaultTheme = (0, create_theme_1.default)();
const CurrentThemeContext = (0, react_1.createContext)(exports.defaultTheme);
exports.Theming = (0, react_jss_1.createTheming)(CurrentThemeContext);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhlbWluZy1jb250ZXh0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vdGhlbWluZy90aGVtaW5nLWNvbnRleHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsaUNBQXNDO0FBQ3RDLHlDQUEwQztBQUUxQyxrRUFBb0Q7QUFFdkMsUUFBQSxZQUFZLEdBQUcsSUFBQSxzQkFBVyxHQUFFLENBQUM7QUFFMUMsTUFBTSxtQkFBbUIsR0FBRyxJQUFBLHFCQUFhLEVBQUMsb0JBQVksQ0FBQyxDQUFDO0FBRTNDLFFBQUEsT0FBTyxHQUFHLElBQUEseUJBQWEsRUFBUSxtQkFBbUIsQ0FBQyxDQUFDIn0=